export default function (data, until, start = 1) {
	let arr = []
	for (let n = start; n <= until; n++) {
		let re = new RegExp(`[a-z_]${n}$`, 'i')
		let obj = {}
		for (let x in data) {
			if (x.match(re)) {
				obj[x.slice(0, -String(n).length)] = data[x]
			}
		}
		obj.n = n
		arr.push(obj)
	}
	return arr
}
